import React from "react";
import { Badge, Button, Card, CardBody, CardHeader } from "reactstrap";
import "../../assets/css/custom_node.css";
import { MdCheck, MdClose } from "react-icons/md";
import { Handle } from "reactflow";
import { IoMdPlay } from "react-icons/io";

function CustomNode({ node, onClick, isActive, nodeData, runStatus }) {
  const {
    data = {},
    fixed = false,
    sourcePosition,
    targetPosition,
    target2Position,
  } = nodeData || {};

  const getClassName = () => {
    switch (runStatus) {
      case null:
        return "";
      case false:
        return <MdClose color="white" size={11} />;
      case true:
        return <MdCheck color="white" size={11} />;
    }
  };

  const getColor = () => {
    switch (runStatus) {
      case "":
        return null;
      case false:
        return "red";
      case true:
        return "green";
    }
    return null;
  };

  return (
    <div>
      <Card className={`custom-node__main ${isActive ? "active-node" : ""}  `}>
        <CardHeader>
          <div
            className={`d-flex justify-content-between align-items-center  `}
            style={{
              display: "flex",
              marginLeft: -5,
              marginRight: -10,
              alignItems: "center",
              alignContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: 5,
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ marginTop: -3 }}>
                <span className="custom-node__title">
                  {data?.type?.title || "NODE SEM TIPO"}
                </span>
              </div>
            </div>

            {getClassName() && (
              <div
                style={{
                  backgroundColor: getColor(),
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: 15,
                  width: 15,
                  height: 15,
                }}
              >
                <span style={{ marginTop: -6 }}>{getClassName()}</span>
              </div>
            )}
            {/* {node.id} */}
          </div>
        </CardHeader>
        <CardBody className="custom-node__body">
          <div className="custom-node__body-content">
            <div className="custom-node__body-content">
              {data?.type?.icon ? (
                <img
                  src={data.type.icon}
                  className={`custom-node__icon ${
                    isActive ? "active-node" : ""
                  }`}
                />
              ) : (
                <div className="custom-node__icon">
                  <IoMdPlay size={20} color="var(--primary)" />
                </div>
              )}

              <span className="custom-node-title">{data?.title}</span>
            </div>

            {sourcePosition && (
              <Handle
                type="source"
                position={sourcePosition}
                id={`source-${node.id}`}
                className="custom-node__handle source"
              />
            )}

            {targetPosition && (
              <Handle
                type="target"
                position={targetPosition}
                id={`target-${node.id}`}
                className="custom-node__handle-target target"
              />
            )}

            {target2Position && (
              <Handle
                type="source"
                position={target2Position}
                id={`target2-${node.id}`}
                className="custom-node__handle-target target2"
              />
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default CustomNode;
